import { OktaAuth } from '@okta/okta-auth-js'

// Shared Okta client singleton, used in both <Security /> wrapper and all authenticated api calls
export const oktaAuth = new OktaAuth({
  issuer: 'https://signifyd.okta.com',
  clientId: '0oa18oep0w8yM1B1z0x8',
  redirectUri: `${window.location.origin}/login/callback`,
  logoutUrl: `${window.location.origin}/login/`,
  responseType: 'code',
  scopes: ['openid'],
})
